import React from "react";
import Head from "next/head";

const Metadata = ({
  title,
  description,
  image = "https://images.prismic.io/mb-web/65b3c529615e73009ec3f6f8_ManhattanBuyersOpenGraphImage.png?auto=format,compress",
  path = "",
}) => {
  return (
    <Head>
      {title && <title>{title ?? "Welcome!"}</title>}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />
      {description && <meta name="description" content={description} />}

      {image && <meta property="og:image" content={image} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}

      {image && <meta property="twitter:image" content={image} />}
      {title && <meta property="twitter:title" content={title} />}
      {description && (
        <meta property="twitter:description" content={description} />
      )}

      {path && (
        <link rel="canonical" href={`https://www.manhattanbuyers.com${path}`} />
      )}
    </Head>
  );
};

export default Metadata;
